var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "label-con flex flex-row align-center justify-between" },
    [
      _c("div", { staticClass: "flex flex-row align-center" }, [
        _c("div", { staticClass: "icon" }),
        _c("div", { staticClass: "label" }, [_vm._v(_vm._s(_vm.label))]),
      ]),
      _c("div", [_vm._t("options")], 2),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }